/* The brand's defaults for new campaigns (v3.3 WF-038, parametres pack, Orchestrator ruling 3 of its vet): the
   « Phrase d’accueil » and the « Photo du salon », kept in this browser per world under `bmr.brand-identity.<monde>` —
   the V1 store (routes/identite/Identite.tsx writes it; a server field is a Technical paper row after the wiring).
   Read here so the lib (WheelDesign, textFor) and the screens share one reading; nothing here writes. */
import { currentWorld } from '@/mocks/worlds'

export interface BrandIdentity { welcome: string | null; photoUrl: string | null }
export const brandIdentityKey = () => `bmr.brand-identity.${currentWorld()}`
export function readBrandIdentity(): BrandIdentity {
  try {
    const raw = localStorage.getItem(brandIdentityKey())
    if (raw) {
      const v = JSON.parse(raw) as Partial<BrandIdentity>
      return { welcome: typeof v.welcome === 'string' && v.welcome.trim() ? v.welcome : null, photoUrl: typeof v.photoUrl === 'string' && v.photoUrl ? v.photoUrl : null }
    }
  } catch { /* private mode / bad JSON */ }
  return { welcome: null, photoUrl: null }
}
